export default "__VITE_ASSET__Hw$w55Nt__"